import * as vp from 'vopay';
import { FunctionComponent, useState } from 'react';
import moment from 'moment';
import styles from './Reconciliation.module.scss';

const { Box, TextField, DateRangePicker, Button, DropDown } = vp;

type SearchFormProps = {
  searchTerm: string;
  hasInvalidEndDate?: boolean;
  shouldShowEndDateError?: boolean;
  setShouldShowEndDateError?: (event: boolean) => void;
  handlePDF: (event: boolean) => void;
  handleCSV: (event: boolean) => void;
  handleXLS: (event: boolean) => void;
  handleDOC: (event: boolean) => void;
  handleText: (event: boolean) => void;
  handleJSON: (event: boolean) => void;
  handleXML: (event: boolean) => void;
  handlePrinting: (event: boolean) => void;
  handleTimeRangeChange: (event: [vp.Timestamp, vp.Timestamp] | undefined) => void;
  handleSearchTermChange: (event: string) => void;
};

type FC = FunctionComponent<SearchFormProps>;

const ReconciliationForm: FC = (props: SearchFormProps) => {
  const {
    searchTerm,
    hasInvalidEndDate,
    shouldShowEndDateError,
    setShouldShowEndDateError,
    handleTimeRangeChange,
    handleSearchTermChange,
    handlePDF,
    handleCSV,
    handleXLS,
    handleDOC,
    handleText,
    handleJSON,
    handleXML,
    handlePrinting,
  } = props;
  const [isMenuVisible, setIsMenuVisible] = useState(false);

  const initialTimeRange: [vp.Timestamp, vp.Timestamp] = [
    moment().subtract(30, 'day').valueOf() as vp.Timestamp,
    moment().valueOf() as vp.Timestamp,
  ];

  return (
    <Box jc="sb" flx="col" width="100%" gap="md">
      <Box gap="sm" wrap="wrap">
        <div className={styles.datePickerContainer}>
          <DateRangePicker
            onChange={handleTimeRangeChange}
            initialTime={initialTimeRange}
            hasInvalidEndDate={hasInvalidEndDate}
            shouldShowEndDateError={shouldShowEndDateError}
            setShouldShowEndDateError={setShouldShowEndDateError}
          />
        </div>
        <Box maxwidth="180px">
          <TextField
            key="AccountSearchKeyword"
            name="AccountSearchKeyword"
            placeholder="Keyword"
            value={searchTerm}
            onBlur={() => {}}
            onChange={(e) => {
              handleSearchTermChange(e.target.value);
            }}
            variant="outlined"
            height="37px"
          />
        </Box>
      </Box>
      <Box width="100%" jc="fe" maxheight="38px">
        <div className={styles.dropdownContainer}>
          <Button
            id="export-transactions"
            color="none"
            label="Export"
            height="38px"
            textSize={1}
            background="transparent"
            noShadow
            icon="arrowDown"
            iconLocation="right"
            onClick={() => {
              setIsMenuVisible(true);
            }}
          />
          {isMenuVisible && (
            <DropDown isMenuVisible={isMenuVisible} onClick={setIsMenuVisible}>
              <Button
                id="export-PDF-btn"
                label="PDF"
                background="transparent"
                textSize={1}
                width="100%"
                noShadow
                onClick={() => {
                  handlePDF(true);
                }}
              />
              <Button
                id="export-CSV-btn"
                label="CSV"
                background="transparent"
                textSize={1}
                width="100%"
                noShadow
                onClick={() => {
                  handleCSV(true);
                }}
              />
              <Button
                id="export-XLS-btn"
                label="XLS"
                background="transparent"
                textSize={1}
                width="100%"
                noShadow
                onClick={() => {
                  handleXLS(true);
                }}
              />
              <Button
                id="export-DOC-btn"
                label="DOC"
                background="transparent"
                textSize={1}
                width="100%"
                noShadow
                onClick={() => {
                  handleDOC(true);
                }}
              />
              <Button
                id="export-Text-btn"
                label="Text"
                background="transparent"
                textSize={1}
                width="100%"
                noShadow
                onClick={() => {
                  handleText(true);
                }}
              />
              <Button
                id="export-JSON-btn"
                label="JSON"
                background="transparent"
                textSize={1}
                width="100%"
                noShadow
                onClick={() => {
                  handleJSON(true);
                }}
              />
              <Button
                id="export-XML-btn"
                label="XML"
                background="transparent"
                textSize={1}
                width="100%"
                noShadow
                onClick={() => {
                  handleXML(true);
                }}
              />
              <Button
                id="export-Print-btn"
                label="Print"
                background="transparent"
                textSize={1}
                width="100%"
                noShadow
                onClick={() => {
                  handlePrinting(true);
                }}
              />
            </DropDown>
          )}
        </div>
      </Box>
    </Box>
  );
};

export default ReconciliationForm;
